import React from 'react';

function Bio({ text }) {
  return (
    <div className="bio">
      <p>{text}</p>
    </div>
  );
}

export default Bio;